import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "_whs-nw" }
const _hoisted_2 = {
  key: 0,
  class: "_td-lt"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_display_currency_renderer = _resolveComponent("display-currency-renderer")
  const _component_currency_conversion_tooltip = _resolveComponent("currency-conversion-tooltip")

  return (_openBlock(), _createBlock(_component_display_currency_renderer, {
    amount: $props.effectivePrice,
    "source-currency-id": $props.sourceCurrencyId,
    "include-commission": true,
    format: $props.format,
    tag: $props.tag
  }, {
    default: _withCtx(({ formattedOriginalAmount, formattedNativeAmount, isConverted }) => [
      _renderSlot(_ctx.$slots, "effective-price", { effectivePrice: formattedOriginalAmount }),
      ($props.isDiscounted)
        ? (_openBlock(), _createBlock(_component_display_currency_renderer, {
            key: 0,
            amount: $props.price,
            "source-currency-id": $props.sourceCurrencyId,
            "include-commission": true,
            format: $props.format,
            tag: "span"
          }, {
            default: _withCtx(({ formattedOriginalAmount: formattedDiscountedPrice }) => [
              _renderSlot(_ctx.$slots, "price", { price: formattedDiscountedPrice })
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["amount", "source-currency-id", "format"]))
        : _createCommentVNode("v-if", true),
      (isConverted && $props.displayTooltip)
        ? (_openBlock(), _createBlock(_component_currency_conversion_tooltip, {
            key: 1,
            variant: $props.variant,
            "icon-classes": $options.computedIconClasses,
            "has-base-class": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(formattedNativeAmount), 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createTextVNode()),
              ($props.isDiscounted)
                ? (_openBlock(), _createElementBlock("s", _hoisted_2, _toDisplayString($options.formattedPrice), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant", "icon-classes"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["amount", "source-currency-id", "format", "tag"]))
}